import { render, staticRenderFns } from "./online.vue?vue&type=template&id=3c8ef0b4&"
import script from "./online.vue?vue&type=script&lang=ts&"
export * from "./online.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports